module.exports = __webpack_public_path__ + "img/fail.ef3c8eb8.svg";